/**
 * داده‌های استان‌ها، شهرستان‌ها و شهرهای ایران
 * ساختار: استان (Province) → شهرستان (County) → شهر (City)
 * فرمت ذخیره: "استان - شهرستان - شهر" یا "استان - شهرستان" برای سازگاری با قبل
 */

// استان → شهرستان → شهرهای آن شهرستان
export const iranProvincesCountiesCities = {
  'تهران': {
    'تهران': ['تهران', 'کهریزک', 'رباط‌کریم', 'شهریار', 'ورامین'],
    'شمیرانات': ['تجریش', 'لواسان', 'فرمانیه', 'سولقان', 'دربند'],
    'ری': ['ری', 'کهریزک', 'فشاپویه', 'قلعه‌نو'],
    'شهریار': ['شهریار', 'فردیس', 'ملارد'],
    'اسلامشهر': ['اسلامشهر', 'چهاردانگه'],
    'ورامین': ['ورامین', 'پاکدشت', 'جوادآباد'],
    'پاکدشت': ['پاکدشت', 'شریف‌آباد'],
    'دماوند': ['دماوند', 'رودهن', 'آبعلی'],
    'فیروزکوه': ['فیروزکوه'],
    'پردیس': ['پردیس'],
    'ملارد': ['ملارد', 'صالحیه'],
    'بهارستان': ['بهارستان', 'گلستان'],
    'قدس': ['قدس'],
    'رباط‌کریم': ['رباط‌کریم', 'نصیرشهر']
  },
  'اصفهان': {
    'اصفهان': ['اصفهان', 'خمینی‌شهر', 'شاهین‌شهر', 'فلاورجان'],
    'کاشان': ['کاشان', 'قمشه', 'نیاسر'],
    'نجف‌آباد': ['نجف‌آباد', 'علویجه'],
    'خمینی‌شهر': ['خمینی‌شهر', 'درچه'],
    'شاهین‌شهر': ['شاهین‌شهر', 'برفانبار'],
    'گلپایگان': ['گلپایگان'],
    'نائین': ['نائین'],
    'نطنز': ['نطنز', 'بادرود'],
    'مبارکه': ['مبارکه', 'دولت‌آباد']
  },
  'خراسان رضوی': {
    'مشهد': ['مشهد', 'طرقبه', 'شاندیز', 'چناران'],
    'نیشابور': ['نیشابور', 'فیروزه'],
    'سبزوار': ['سبزوار', 'ششتمد'],
    'تربت حیدریه': ['تربت حیدریه', 'کدکن'],
    'قوچان': ['قوچان', 'فاروج'],
    'گناباد': ['گناباد', 'بجستان'],
    'کاشمر': ['کاشمر', 'بردسکن'],
    'تربت جام': ['تربت جام', 'صالح‌آباد']
  },
  'فارس': {
    'شیراز': ['شیراز', 'مرودشت', 'کوار', 'زرقان'],
    'مرودشت': ['مرودشت', 'سیدان'],
    'جهرم': ['جهرم', 'خنج'],
    'کازرون': ['کازرون', 'کنارتخته'],
    'فسا': ['فسا'],
    'آباده': ['آباده', 'بهمن'],
    'لار': ['لار', 'گراش'],
    'نی‌ریز': ['نی‌ریز'],
    'داراب': ['داراب', 'جنت‌شهر']
  },
  'آذربایجان شرقی': {
    'تبریز': ['تبریز', 'سردرود', 'باسمنج'],
    'مراغه': ['مراغه', 'سراجو'],
    'مرند': ['مرند', 'یامچی'],
    'میانه': ['میانه', 'ترکمانچای'],
    'شبستر': ['شبستر', 'تسوج'],
    'بناب': ['بناب'],
    'سراب': ['سراب'],
    'جلفا': ['جلفا', 'هادیشهر']
  },
  'آذربایجان غربی': {
    'ارومیه': ['ارومیه', 'سلماس', 'نوشین‌شهر'],
    'خوی': ['خوی', 'قره‌ضیاءالدین'],
    'مهاباد': ['مهاباد', 'بوکان'],
    'بوکان': ['بوکان'],
    'میاندوآب': ['میاندوآب', 'مراغه'],
    'سلماس': ['سلماس', 'نقده'],
    'پیرانشهر': ['پیرانشهر', 'سردشت']
  },
  'خوزستان': {
    'اهواز': ['اهواز', 'باوی', 'حمیدیه'],
    'آبادان': ['آبادان', 'خرمشهر'],
    'دزفول': ['دزفول', 'شوشتر'],
    'خرمشهر': ['خرمشهر', 'آبادان'],
    'بهبهان': ['بهبهان', 'آغاجاری'],
    'شوشتر': ['شوشتر', 'گتوند'],
    'اندیمشک': ['اندیمشک', 'شوش'],
    'شوش': ['شوش', 'شاوور'],
    'ایذه': ['ایذه', 'باغ‌ملک']
  },
  'قم': { 'قم': ['قم'] },
  'البرز': {
    'کرج': ['کرج', 'محمدشهر', 'گلستان', 'فردیس'],
    'ساوجبلاغ': ['هشتگرد', 'طالقان'],
    'نظرآباد': ['نظرآباد', 'تنکمان'],
    'فردیس': ['فردیس', 'محمدشهر']
  },
  'گیلان': {
    'رشت': ['رشت', 'لاهیجان', 'انزلی'],
    'انزلی': ['بندر انزلی', 'پیربازار'],
    'لاهیجان': ['لاهیجان', 'رودبنه'],
    'لنگرود': ['لنگرود', 'چاف'],
    'رودسر': ['رودسر', 'کلاچای'],
    'تالش': ['هشتپر', 'اسالم'],
    'آستارا': ['آستارا', 'لوندویل']
  },
  'مازندران': {
    'ساری': ['ساری', 'میاندورود', 'کوهستان'],
    'بابل': ['بابل', 'بابلکنار', 'گتاب'],
    'آمل': ['آمل', 'دابودشت'],
    'قائم‌شهر': ['قائم‌شهر', 'جویبار'],
    'بابلسر': ['بابلسر', 'بهنمیر'],
    'تنکابن': ['تنکابن', 'خرم‌آباد'],
    'چالوس': ['چالوس', 'مرزن‌آباد'],
    'نور': ['نور', 'رویان'],
    'رامسر': ['رامسر', 'کتالم']
  },
  'گلستان': {
    'گرگان': ['گرگان', 'نوده‌خاندوز'],
    'گنبد کاووس': ['گنبد کاووس', 'اینچه‌برون'],
    'علی‌آباد': ['علی‌آباد', 'فاضل‌آباد'],
    'آق‌قلا': ['آق‌قلا', 'بندر ترکمن'],
    'بندر ترکمن': ['بندر ترکمن'],
    'کردکوی': ['کردکوی', 'فارسان'],
    'مینودشت': ['مینودشت', 'گالیکش'],
    'کلاله': ['کلاله', 'مراوه‌تپه']
  },
  'یزد': {
    'یزد': ['یزد', 'شاهدیه', 'زارچ'],
    'میبد': ['میبد', 'ندوشن'],
    'اردکان': ['اردکان', 'عقدا'],
    'بافق': ['بافق', 'بهاباد'],
    'مهریز': ['مهریز', 'مروست'],
    'تفت': ['تفت', 'نیر'],
    'ابرکوه': ['ابرکوه', 'بهاباد']
  },
  'کرمان': {
    'کرمان': ['کرمان', 'شهربابک', 'رفسنجان'],
    'رفسنجان': ['رفسنجان', 'انار'],
    'سیرجان': ['سیرجان', 'نجف‌شهر'],
    'جیرفت': ['جیرفت', 'عنبرآباد'],
    'شهربابک': ['شهربابک', 'دهج'],
    'بم': ['بم', 'بروات'],
    'زرند': ['زرند', 'خان‌ببین'],
    'بردسیر': ['بردسیر', 'گلزار']
  },
  'همدان': {
    'همدان': ['همدان', 'قهاوند', 'جورقان'],
    'ملایر': ['ملایر', 'سامن'],
    'نهاوند': ['نهاوند', 'گیان'],
    'تویسرکان': ['تویسرکان', 'سرکان'],
    'کبودرآهنگ': ['کبودرآهنگ', 'گل تپه'],
    'اسدآباد': ['اسدآباد', 'درگزین'],
    'بهار': ['بهار', 'صالح‌آباد']
  },
  'مرکزی': {
    'اراک': ['اراک', 'ساوه', 'خمین'],
    'ساوه': ['ساوه', 'نراق'],
    'خمین': ['خمین', 'قورچی‌باشی'],
    'محلات': ['محلات', 'نیم‌ور'],
    'دلیجان': ['دلیجان', 'نراق'],
    'شازند': ['شازند', 'آستانه'],
    'کمیجان': ['کمیجان', 'میلاجرد']
  },
  'لرستان': {
    'خرم‌آباد': ['خرم‌آباد', 'معمولان'],
    'بروجرد': ['بروجرد', 'اشترینان'],
    'دورود': ['دورود', 'ازنا'],
    'الیگودرز': ['الیگودرز', 'شول‌آباد'],
    'ازنا': ['ازنا', 'مومن‌آباد'],
    'کوهدشت': ['کوهدشت', 'دلفان'],
    'دوره': ['دوره', 'چغلوندی']
  },
  'کردستان': {
    'سنندج': ['سنندج', 'قروه', 'دهگلان'],
    'سقز': ['سقز', 'بانه'],
    'مریوان': ['مریوان', 'سروآباد'],
    'بانه': ['بانه', 'آرمرده'],
    'قروه': ['قروه', 'دهگلان'],
    'بیجار': ['بیجار', 'یاسوکند'],
    'کامیاران': ['کامیاران', 'موچش'],
    'دیواندره': ['دیواندره', 'زرینه']
  },
  'کرمانشاه': {
    'کرمانشاه': ['کرمانشاه', 'اسلام‌آباد', 'سنقر'],
    'اسلام‌آباد': ['اسلام‌آباد', 'حمیل'],
    'پاوه': ['پاوه', 'نودشه'],
    'سنقر': ['سنقر', 'کلیایی'],
    'هرسین': ['هرسین', 'بیستون'],
    'قصرشیرین': ['قصرشیرین'],
    'سرپل‌ذهاب': ['سرپل‌ذهاب', 'قصرشیرین'],
    'کنگاور': ['کنگاور', 'گودین']
  },
  'ایلام': {
    'ایلام': ['ایلام', 'مهران'],
    'دهلران': ['دهلران', 'موسیان'],
    'ایوان': ['ایوان', 'زرنه'],
    'مهران': ['مهران', 'صالح‌آباد'],
    'دره‌شهر': ['دره‌شهر', 'بدره']
  },
  'بوشهر': {
    'بوشهر': ['بوشهر', 'گناوه'],
    'برازجان': ['برازجان', 'دشتستان'],
    'گناوه': ['گناوه', 'ریگ'],
    'دیر': ['دیر', 'بردخون'],
    'کنگان': ['کنگان', 'سیراف'],
    'جم': ['جم', 'ریز'],
    'دشتستان': ['برازجان', 'شبانکاره']
  },
  'هرمزگان': {
    'بندرعباس': ['بندرعباس', 'قشم', 'کیش'],
    'میناب': ['میناب', 'سیریک'],
    'جاسک': ['جاسک', 'سیریک'],
    'رودان': ['دهبارز', 'رودان'],
    'بندر لنگه': ['بندر لنگه', 'کنگ'],
    'قشم': ['قشم', 'درگهان'],
    'کیش': ['کیش'],
    'ابوموسی': ['ابوموسی']
  },
  'سیستان و بلوچستان': {
    'زاهدان': ['زاهدان', 'میرجاوه'],
    'زابل': ['زابل', 'هیرمند'],
    'چابهار': ['چابهار', 'کنارک'],
    'ایرانشهر': ['ایرانشهر', 'بزمان'],
    'خاش': ['خاش', 'نیک‌شهر'],
    'سراوان': ['سراوان', 'سرباز'],
    'نیک‌شهر': ['نیک‌شهر', 'فنوج'],
    'سرباز': ['سرباز', 'راسک']
  },
  'چهارمحال و بختیاری': {
    'شهرکرد': ['شهرکرد', 'بروجن', 'فارسان'],
    'بروجن': ['بروجن', 'بلداجی'],
    'فارسان': ['فارسان', 'چلگرد'],
    'لردگان': ['لردگان', 'فلارد'],
    'کوهرنگ': ['چلگرد', 'بازفت'],
    'بن': ['بن', 'وردنجان'],
    'اردل': ['اردل', 'کاج']
  },
  'کهگیلویه و بویراحمد': {
    'یاسوج': ['یاسوج', 'دهدشت', 'گچساران'],
    'دهدشت': ['دهدشت', 'چرام'],
    'گچساران': ['گچساران', 'دوگنبدان'],
    'دنا': ['سی‌سخت', 'پاتاوه'],
    'بهمئی': ['لیکک', 'سوق'],
    'باغ‌ملک': ['باغ‌ملک', 'منگشت']
  },
  'خراسان شمالی': {
    'بجنورد': ['بجنورد', 'اسفراین', 'جاجرم'],
    'اسفراین': ['اسفراین', 'صفی‌آباد'],
    'شیروان': ['شیروان', 'فاروج'],
    'فاروج': ['فاروج', 'گرمه'],
    'گرمه': ['گرمه', 'راز و جرگلان']
  },
  'خراسان جنوبی': {
    'بیرجند': ['بیرجند', 'قائنات', 'طبس'],
    'قائنات': ['قائن', 'فردوس'],
    'طبس': ['طبس', 'دیهوک'],
    'فردوس': ['فردوس', 'اسلامیه'],
    'نهبندان': ['نهبندان', 'شوسف'],
    'سرایان': ['سرایان', 'سه‌قلعه'],
    'بشرویه': ['بشرویه', 'ارسک']
  },
  'زنجان': {
    'زنجان': ['زنجان', 'ابهر', 'خدابنده'],
    'ابهر': ['ابهر', 'قیدار'],
    'خدابنده': ['قیدار', 'زرین‌آباد'],
    'طارم': ['طارم', 'چورزق'],
    'ماه‌نشان': ['ماه‌نشان', 'دندی'],
    'ایجرود': ['زرین‌رود', 'خرمدره'],
    'خرمدره': ['خرمدره', 'قیدار']
  },
  'قزوین': {
    'قزوین': ['قزوین', 'تاکستان', 'آبیک'],
    'تاکستان': ['تاکستان', 'اسفرورین'],
    'آبیک': ['آبیک', 'محمدیه'],
    'بوئین‌زهرا': ['بوئین‌زهرا', 'شال'],
    'البرز': ['البرز', 'محمدیه'],
    'آوج': ['آوج', 'دانسفهان']
  },
  'اردبیل': {
    'اردبیل': ['اردبیل', 'خلخال', 'مشگین‌شهر'],
    'خلخال': ['خلخال', 'هشجین'],
    'مشگین‌شهر': ['مشگین‌شهر', 'لاهرود'],
    'پارس‌آباد': ['پارس‌آباد', 'اصلاندوز'],
    'نیر': ['نیر', 'سرعین'],
    'نمین': ['نمین', 'گرده'],
    'سرعین': ['سرعین', 'نیر']
  }
};

// سازگاری با قبل: استان → شهرستان‌ها (بدون شهر)
export const iranProvincesWithCounties = {
  'تهران': ['تهران', 'شمیرانات', 'ری', 'شهریار', 'اسلامشهر', 'ورامین', 'پاکدشت', 'دماوند', 'فیروزکوه', 'پردیس', 'ملارد', 'بهارستان', 'قدس', 'رباط‌کریم'],
  'اصفهان': ['اصفهان', 'کاشان', 'نجف‌آباد', 'خمینی‌شهر', 'شاهین‌شهر', 'گلپایگان', 'نائین', 'نطنز', 'فریدن', 'فریدون‌شهر', 'دولت‌آباد', 'مبارکه'],
  'خراسان رضوی': ['مشهد', 'نیشابور', 'سبزوار', 'تربت حیدریه', 'قوچان', 'گناباد', 'کاشمر', 'تربت جام', 'چناران', 'بجستان', 'بردسکن'],
  'فارس': ['شیراز', 'مرودشت', 'جهرم', 'کازرون', 'فسا', 'آباده', 'لار', 'نی‌ریز', 'استهبان', 'داراب', 'ممسنی'],
  'آذربایجان شرقی': ['تبریز', 'مراغه', 'مرند', 'میانه', 'شبستر', 'بناب', 'سراب', 'هشترود', 'جلفا', 'کلیبر'],
  'آذربایجان غربی': ['ارومیه', 'خوی', 'مهاباد', 'بوکان', 'میاندوآب', 'سلماس', 'نقده', 'پیرانشهر', 'سردشت'],
  'خوزستان': ['اهواز', 'آبادان', 'دزفول', 'خرمشهر', 'بهبهان', 'شوشتر', 'اندیمشک', 'شوش', 'ایذه', 'رامشیر'],
  'قم': ['قم'],
  'البرز': ['کرج', 'ساوجبلاغ', 'نظرآباد', 'طالقان', 'اشتهارد', 'فردیس'],
  'گیلان': ['رشت', 'انزلی', 'لاهیجان', 'لنگرود', 'رودسر', 'تالش', 'صومعه‌سرا', 'فومن', 'ماسال', 'آستارا'],
  'مازندران': ['ساری', 'بابل', 'آمل', 'قائم‌شهر', 'بابلسر', 'تنکابن', 'چالوس', 'نور', 'نکا', 'رامسر'],
  'گلستان': ['گرگان', 'گنبد کاووس', 'علی‌آباد', 'آق‌قلا', 'بندر ترکمن', 'کردکوی', 'مینودشت', 'کلاله'],
  'یزد': ['یزد', 'میبد', 'اردکان', 'بافق', 'مهریز', 'تفت', 'ابرکوه'],
  'کرمان': ['کرمان', 'رفسنجان', 'سیرجان', 'جیرفت', 'شهربابک', 'بم', 'زرند', 'بردسیر'],
  'همدان': ['همدان', 'ملایر', 'نهاوند', 'تویسرکان', 'کبودرآهنگ', 'اسدآباد', 'بهار'],
  'مرکزی': ['اراک', 'ساوه', 'خمین', 'محلات', 'دلیجان', 'تفرش', 'شازند', 'کمیجان'],
  'لرستان': ['خرم‌آباد', 'بروجرد', 'دورود', 'الیگودرز', 'ازنا', 'دلفان', 'کوهدشت', 'دوره'],
  'کردستان': ['سنندج', 'سقز', 'مریوان', 'بانه', 'قروه', 'بیجار', 'کامیاران', 'دیواندره'],
  'کرمانشاه': ['کرمانشاه', 'اسلام‌آباد', 'پاوه', 'سنقر', 'هرسین', 'قصرشیرین', 'سرپل‌ذهاب', 'کنگاور'],
  'ایلام': ['ایلام', 'دهلران', 'ایوان', 'شیروان و چرداول', 'مهران', 'دره‌شهر'],
  'بوشهر': ['بوشهر', 'برازجان', 'گناوه', 'دیر', 'کنگان', 'جم', 'دشتستان'],
  'هرمزگان': ['بندرعباس', 'میناب', 'جاسک', 'رودان', 'بندر لنگه', 'قشم', 'کیش', 'ابوموسی'],
  'سیستان و بلوچستان': ['زاهدان', 'زابل', 'چابهار', 'ایرانشهر', 'خاش', 'سراوان', 'نیک‌شهر', 'سرباز'],
  'چهارمحال و بختیاری': ['شهرکرد', 'بروجن', 'فارسان', 'لردگان', 'کوهرنگ', 'بن', 'اردل'],
  'کهگیلویه و بویراحمد': ['یاسوج', 'دهدشت', 'گچساران', 'دنا', 'بهمئی', 'باغ‌ملک'],
  'خراسان شمالی': ['بجنورد', 'اسفراین', 'جاجرم', 'شیروان', 'فاروج', 'گرمه', 'راز و جرگلان'],
  'خراسان جنوبی': ['بیرجند', 'قائنات', 'طبس', 'فردوس', 'نهبندان', 'سرایان', 'بشرویه'],
  'زنجان': ['زنجان', 'ابهر', 'خدابنده', 'طارم', 'ماه‌نشان', 'ایجرود', 'خرمدره'],
  'قزوین': ['قزوین', 'تاکستان', 'آبیک', 'بوئین‌زهرا', 'البرز', 'آوج'],
  'اردبیل': ['اردبیل', 'خلخال', 'مشگین‌شهر', 'پارس‌آباد', 'نیر', 'نمین', 'سرعین']
};

// لیست مسطح برای سازگاری با کد قبلی (استان‌ها)
export const iranProvinces = Object.keys(iranProvincesWithCounties);

// تولید لیست شهرستان‌ها با فرمت "استان - شهرستان" برای ذخیره و نمایش
export const getAllCountiesFormatted = () => {
  const result = [];
  Object.entries(iranProvincesWithCounties).forEach(([province, counties]) => {
    counties.forEach(county => {
      result.push({
        value: province === county ? province : `${province} - ${county}`,
        label: province === county ? province : `${province} - ${county}`,
        province,
        county
      });
    });
  });
  return result;
};

// فرمت مقدار برای ذخیره (سازگار با داده‌های قبلی)
export const formatLocationValue = (province, county, city) => {
  if (!province) return 'کل ایران';
  if (!county) return province;
  if (!city || county === city) return province === county ? province : `${province} - ${county}`;
  return `${province} - ${county} - ${city}`;
};

// تولید لیست مسطح همه مکان‌ها: استان › شهرستان › شهر
export const getAllLocationsFormatted = () => {
  const result = [];
  Object.entries(iranProvincesCountiesCities).forEach(([province, counties]) => {
    Object.entries(counties).forEach(([county, cities]) => {
      cities.forEach(city => {
        const value = formatLocationValue(province, county, city);
        result.push({
          value,
          label: city,
          province,
          county,
          city,
          fullPath: `${province} › ${county} › ${city}`
        });
      });
    });
  });
  return result;
};

// تبدیل مقدار ذخیره‌شده به مسیر نمایشی (استان › شهرستان › شهر)
export const getLocationDisplayLabel = (storedValue) => {
  if (!storedValue || storedValue === 'کل ایران') return storedValue || 'کل ایران';
  return storedValue.replace(/ - /g, ' › ');
};

/** جداکننده‌های متداول در مسیر مکان (ذخیره یا نمایش) */
const splitLocationSegments = (raw) => {
  if (!raw) return [];
  const s = String(raw).trim();
  const SEP = '\u0001';
  const marked = s
    .replace(/\s*›\s*/g, SEP)
    .replace(/\s*\/\s*/g, SEP)
    .replace(/\s*-\s*/g, SEP);
  return marked.split(SEP).map((x) => x.trim()).filter(Boolean);
};

/**
 * برای کارت‌های خلاصه: **مرکز شهری اصلی** (مثل تهران، مشهد، ارومیه) نه حومهٔ آخر.
 * برای مسیر «استان - شهر مرکزی - ناحیه» بخش میانی برمی‌گردد؛ برای «استان - شهر» همان شهر؛
 * تک‌بخشی همان متن. آدرس کامل را با getLocationDisplayLabel در title نشان دهید.
 */
export const getLocationCardShortLabel = (storedValue) => {
  if (!storedValue || storedValue === 'کل ایران') return storedValue || 'کل ایران';
  const segments = splitLocationSegments(storedValue);
  if (segments.length <= 1) return segments[0] || String(storedValue).trim();
  // دو بخش و بیشتر: معمولاً [استان، شهر اصلی، …] → شهر اصلی همان index 1
  return segments[1];
};

// برای جستجو و فیلتر - آیا مقدار با استان، شهرستان یا شهر مطابقت دارد؟
export const matchesLocation = (storedValue, filterValue) => {
  if (!filterValue || filterValue === 'کل ایران') return true;
  if (!storedValue) return false;
  if (storedValue === filterValue) return true;
  // فیلتر "تهران" با "تهران - شمیرانات" و "تهران - شمیرانات - تجریش" match شود
  if (storedValue.startsWith(filterValue + ' - ') || storedValue.startsWith(filterValue + ' ')) return true;
  // فیلتر "تهران - شمیرانات" با "تهران - شمیرانات - تجریش" match شود
  if (filterValue.includes(' - ') && storedValue.startsWith(filterValue)) return true;
  return false;
};
